<template>
  <div class="products-result-base" :style="styles">
    <div class="header-area">
      <h1>MITSURI<br>暴露数鑑定書<span class="subtitle"></span></h1>
      <img src="/static/img/recommend/lp/houen/products/reslut_topimg.png">
      <p>暴露数は、隠れた本当のあなたを発見できる占いです。この暴露数鑑定書では、あなたのの中にある、２つの個性を導き出します。その２つの個性は、状況によって、表に出てくる個性が違います。それぞれの個性を知ることで、これまで不思議だった人の行動や、さらに深く自分自身を知るきっかけになるはずです。</p>
      <h2 class="lead-text">あなたの中にある<br>２つの本質を紐解いてみましょう。</h2>
      <img class="line" src="/static/img/recommend/lp/houen/products/creamline.png">
    </div>
    <!-- ↑副題のところ以外は画像(svg)で良いと思う -->
    <block-result-type01
      base-title="あなたの本質"
      :result-data="resultData"
      :csrf-token="csrfToken"
    />

    <div class="block-regist-info">
      <img class="line-top" src="/static/img/recommend/lp/houen/products/whiteline_top.png">
      <h2></h2>
      <regist-birthdate
        header-word="他の誕生日で占う"
        reg-btn-face="占う"
        :csrf-token="csrfToken"
      />
      <img class="line-bottom" src="/static/img/recommend/lp/houen/products/whiteline_bottom.png">
    </div>

    <link-menu-block />
    <!-- <banner-block /> -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import * as type from '@/utvStore/store/mutation-types'
import RegistBirthdate from "../partials/RegistBirthdate";
import BannerBlock from '../partials/BannerBlock';
import LinkMenuBlock from '../partials/LinkMenuBlock';
import BlockResultType01 from "../partials/BlockResultType01";
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'

export default {
  name: 'ProductsResult01',
  components: {
    RecommendBlockPlus,
    BlockResultType01,
    RegistBirthdate,
    BannerBlock,
    LinkMenuBlock,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    resultData: {
      //type: Object,
      type: [Object, Array],
      default: null,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.user,
      userProf: state => state.account.profile,
      subscInfo: state => state.account.subscription
    }),
    counselorInfos(){
      return BASIC_DATA.houen
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
        '--second': this.counselorInfos.colorScheme.second,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
  },
  methods: {
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables";
@import "../../../../../../sass/commons/styles/fonts";


$title-fontfamily:'Hiragino Mincho Pro';

.products-result-base {
  background: #f8f5ed;
  .header-area{
    background-size: contain;
    background-image: url(/static/img/recommend/lp/houen/products/bk_result.png);
    background-repeat-y: repeat;
    padding: 40px 20px 0;
    .line{
      width: 100vw;
      height: auto;
      margin-bottom: -3px;
      margin: 0 calc(50% - 50vw);
      margin-bottom: -3px;

      @include mq('w580'){
        width: 580px;
        height: auto;
        margin: 0;
        margin-bottom: -5px;
        margin-left: -20px;
        }

    }
    h1{
      @extend .source-han-serif-bold;
      //font-style: normal;
      //font-weight: 600;
      //font-family: $title-fontfamily;
      font-size: 24px;
      line-height: 32px;
      border-bottom:1px solid var(--key-color) ;
      margin: 0 auto 24px;
      text-align: center;
      display: block;
      width: 180px;
      color: var(--key-color);
      letter-spacing: 6px;
      padding-bottom: 10px;
    }
    img{
      width:130px;
      height: 130px;
      margin: auto;
      display: block;
    }
    p{
      //font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: $col_base_black;
      margin-bottom: 40px;
    }
    .lead-text{
      @extend .source-han-serif-bold;
      //font-family:$title-fontfamily;
      //font-family: $title-fontfamily;
      //font-style: normal;
      //font-weight: 600;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      letter-spacing: 1px;
      color: var(--key-color);
      margin: 0;
      margin-bottom: 24px;
    }
  }
  .result-panel-base{

    .target-text{
      //font-family: 'Hiragino Kaku Gothic Pro';
      font-style: normal;
      //font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      color: $col_base_black;
      margin-bottom: 24px;
    }
    .target-title{
      //font-family: 'Hiragino Kaku Gothic Pro';
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color:var(--key-color);
      margin-bottom: 20px;
    }
  }


  .block-regist-info{
    position: relative;
    background: #f8f5ed;
    .line-top{
      position: absolute;
      top: -13px;
      height: auto;
      width: 100%;
    }
    .line-bottom{
      width: 100%;
      height: auto;
      position: absolute;
      bottom: -12px;
    }
  }
  .regist-birthdate{
    background: #fff;
    border-radius: 0px;
  }





}
/deep/{
  .block-banners img{
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/fortunes/ProductsResult01.vue